export namespace RootActions {
	export class GetContent {
		static readonly type = '[Root] Get Content';
		constructor(
			public schoolID: number,
			public culture: string
		) {}
	}

	export class GetSchools {
		static readonly type = '[Root] Get Schools';
		constructor(public culture: string) {}
	}

	export class SetCulture {
		static readonly type = '[Root] Set Culture';
		constructor(public culture: string) {}
	}
}
